class AbortError extends Error {}

export default AbortError;
